
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"location","fill":"none","stroke":"#e0e4ec","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M12.6 8.592a2.6 2.6 0 11-2.6-2.6 2.6 2.6 0 012.6 2.6z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.014 7.075C4.658-.141 15.35-.133 16.983 7.084c.958 4.233-1.675 7.817-3.983 10.033a4.328 4.328 0 01-6.008 0C4.691 14.9 2.058 11.309 3.014 7.075z"}})])])
          )
        }
      }
    